import React, { useContext } from 'react'
import opt from 'images/optimization (2).png'
import { themeContext } from 'contexts/theme_context/ThemeContext'
import { useNavigate } from 'react-router'
export default function Maintenance() {
    let { webtheme } = useContext(themeContext)
    let navto = useNavigate()
    return (
        <div className='vh-100 col-12 d-flex align-items-center justify-content-center position-fixed'>
            <div className={`col-lg-3 col-sm-5 col-xs-6  d-flex flex-column align-items-center`}>
                <div className='col-12 text-center my-1 '>
                    <h1 className={`fs-5 fw-bold   overflow-hidden ${webtheme}-text`}>Sorry, we are down for maintenance.</h1>
                </div>
                <div className='col-12 text-center my-1 mb-2 '>
                    <h2 className={`fs-6 fw-thin   overflow-hidden ${webtheme}-text`}>we will be back up shortly.</h2>
                </div>
                <div className='col-10'>
                    <img src={opt} alt="" className='col-12' />
                </div>

            </div>
        </div>
    )
}
